import {
  SimpleForm,
  FileInput,
  FileField,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  TabbedForm,
  FormTab,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  NumberInput
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { bank } from "../../constant/Bank";

const ProjectForm = props => {
  return (
    <TabbedForm {...props}>
      <FormTab label="project.tab.general">
        <TextInput source="name" label="ชื่อโครงการภาษาไทย" validate={[required()]} />
        <TextInput source="name_en" label="ชื่อโครงการภาษาอังกฤษ" validate={[required()]} />
        <TextInput source="name_jp" label="ชื่อโครงการภาษาญี่ปุ่น" validate={[required()]} />
        <TextInput source="name_zh" label="ชื่อโครงการภาษาจีน" validate={[required()]} />
        <TextInput fullWidth source="project_progress" />
        <TextInput source="tel" label="หมายเลขฉุกเฉิน" />
        <NumberInput source="location[1]" label="Latitude" style={{ marginRight: 20, float: 'left' }} />
        <NumberInput source="location[0]" label="Longitude" />
        {/* <FileInput source="room_rates" label="ราคาห้อง" accept="application/pdf">
                <FileField source="url" title="Room Rates" />
            </FileInput> */}
      </FormTab>
      <FormTab label="project.tab.payment">
        <ImageInput
          multiple={false}
          source="payment.qr"
          label="QR Payment"
          accept="image/*"
        >
          <ImageField source="url" title="QR" />
        </ImageInput>
        <ArrayInput source="payment.account">
          <SimpleFormIterator>
            <SelectInput
              validate={[required()]}
              source="bank"
              label="ธนาคาร"
              choices={bank}
            />
            <TextInput validate={[required()]} label="เลขบัญชี" source="no" />
            <TextInput
              validate={[required()]}
              label="ชื่อบัญชี"
              source="name"
            />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  );
};

export default ProjectForm;



// WEBPACK FOOTER //
// ./src/components/project/ProjectForm.js